import sanitizeHtml from "sanitize-html";

/**
 * Parse HTML content and extract plain text lines.
 * Useful for rendering HTML content in react-pdf which doesn't support full HTML.
 */
export const parseHtmlToLines = (html: string): string[] => {
    // Convert block elements to newlines before sanitizing
    const withLineBreaks = html.replace(/<br\s*\/?>/gi, "\n").replace(/<\/?(p|div)[^>]*>/gi, "\n");

    const plainText = sanitizeHtml(withLineBreaks, {allowedTags: []});

    return plainText
        .split(/\n+/)
        .map(line => line.trim())
        .filter(line => line.length > 0);
};

/**
 * Check if a payment type represents a credit payment.
 * Normalizes the check to handle case variations.
 */
export const isCreditPayment = (paymentType: string): boolean => {
    return paymentType.toLowerCase() === "credit";
};

/**
 * Check if a string contains HTML tags.
 * Looks for opening tags with optional attributes, or self-closing tags.
 */
export const containsHtml = (text: string): boolean => {
    // Matches: <tag>, <tag attr="value">, <tag/>, <tag />
    return /<[a-z][a-z0-9]*(?:\s[^>]*)?\/?>/i.test(text);
};

export const mapPaymentType = (type: string): string => {
    if (type === "mail") {
        return "Mail";
    }
    if (type === "stripe") {
        return "Stripe";
    }

    return type;
};
